export default {
	sec_01: {
		title: {
			one: 'Accept online and',
			two: 'Face-to-Face',
			three: ' Payments',
		},
		btn: {
			one: 'Sign up',
			two: 'Contact Sales Department',
		},
	},
	sec_14: {
		btn: 'Contact your account specialist to get started.',
	},
	sec_03: {
		title: {
			one: 'Gain a competitive advantage',
		},
		desc: {
			one: 'We help small businesses to receive payments almost everywhere.',
		},
		one: {
			title: {
				one: 'Flexibility required',
				two: 'by customers',
			},
			desc: {
				one: 'Have customers pay later, sign up for a subscription,',
				two: 'or use global or local payment options.',
			},
		},
		two: {
			title: {
				one: 'Connect with global buyers',
			},
			desc: {
				one: 'Payments are accepted online or in stores',
				two: 'with all cryptocurrencies.',
			},
		},
		three: {
			title: {
				one: 'Accept Online',
				two: 'Payment',
			},
			desc: {
				one: 'Make sure your customers pay the way they want and make',
				two: 'payments quickly. ',
				three: 'Learn more about accepting payments online.',
			},
		},
	},
	sec_15: {
		title: {
			one: 'Introducing the benefits of JP WORLD Pay.',
		},
		cards: {
			one: {
				title: {
					one: 'Online Checkout',
				},
				description: {
					one: 'Customers can use a variety of payment',
					two: 'methods on a site, mobile or app as a ',
					three: 'single solution.',
				},
				btn_01: {
					one: 'More information about',
					two: 'online checkout',
				},
				btn_02: {
					one: 'More information about',
					two: 'subscription services.',
				},
			},
			two: {
				title: {
					one: 'Invoice and Estimate',
				},
				description: {
					one: 'You can encourage customers to pay by',
					two: 'sending free custom invoices that are',
					three: 'easy to pay.',
				},
				btn: {
					one: 'More information about',
					two: 'issuing an invoice',
				},
			},
			three: {
				title: {
					one: 'Sale on Socials',
				},
				description: {
					one: 'Receive payment using our JP WORLD Pay',
					two: 'payment system on various social ',
					three: 'media platforms.',
				},
				btn: {
					one: 'Learn more about',
					two: 'social sales',
				},
			},
			four: {
				title: {
					one: 'Online Cryptocurrency ',
					two: 'Payment System',
				},
				description: {
					one: 'Our credit and online payment services',
					two: 'allow you to accept online and in-store ',
					three: 'payments with most major cryptocurrencies.',
				},
			},
			five: {
				title: {
					one: 'Accept Direct Payment',
				},
				description: {
					one: 'Have the customer pay while shopping',
					two: 'themselves. here Find out how it works',
				},
			},
			six: {
				title: {
					one: 'Point of Sale',
				},
				description: {
					one: 'Manage JP WORLD Pay Settings business,',
					two: 'the perfect POS solution, by accepting all ',
					three: 'types of popular transactions and ',
					four: 'tracking sales.',
				},
				btn: {
					one: 'Learn more about',
					two: 'JP WORLD Pay Settings',
				},
			},
		},
	},
	common: {
		coming_soon: 'Coming soon.',
	},
};
